<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1VX4tL/tc-custom/9781597480376.jpg?1680370567021" alt="This image is the cover for the book Enchanted Frost, Bitter Frost Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enchanted Frost, Bitter Frost Series
      </h1>
      <p class="bookDescription body article font2">
        <p>If you like Anne Rice, Sarah Maas, and Neil Gaiman's fantasy books, you'll love Kailin Gow's epic fantasies like this one.  The wedding is off, and the groom-to-be is no longer. Prince Kian has left Feyland, trying to forget Breena and all memories of her. Failing to fight off the human affliction known as love by himself, he seeks the magic of the Ancient Realms, to forget his love for Breena, to become truly fey, strong, stoic, and cold...just as the son his mother the Winter Queen had always wanted. While Kian has disappeared, Breena is left ruling Feyland and still in the beginning of rebuilding. Her heart aches for Kian, but now because of the Wolfstone, Logan and all the wolf fey's magic has been restored. And a werewolf let loose with full fey magic is an enchanted Feyland to behold. But could Logan's newfound magic and role in Breena's life be enough for Breena to forget Kian?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kailin Gow
      </h2>
      
      <p class="authorDescription body article">Kailin Gow is a million-selling author who has written and published close to 700 books under her name and various pen names in multiple genres since 2001. She is also an award-winning filmmaker whose films has screened all over the world including Cannes, Los Angeles, London, Paris, Japan, Korea, India, Germany, and Greece. Her books Bitter Frost and PULSE Vampires have been made into video games and is currently filming as featured films. She has been named as the most prolific Asian American author, and has been quoted as the representative for AAPI Heritage Week. Currently, two of her book series, Red Genesis, co-written by Kira G. and her science fiction romance series FADE have been optioned by the Netflix Top 2 Overall film production company Wish Dragon. She is set to write and direct the AAPI diverse cast featured film of Jane Austen’s Pride and Prejudice.  As an actress, she is currently in pre-production to star in 4 AAPI-led films, including her enemies-to-lover novel based on her relative’s ramen factory called Ramen Romance and her real-life experience as an author who has organized some of the biggest book signing events in her novel Love Letters from Las Vegas.  Go to KailinGow.com tfor updates and news.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sparklesoup.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1eefafb1